module.exports = __webpack_public_path__ + "static/media/tz.013a918c.svg";